// @flow

import React, { createContext, useContext, useState,ReactNode } from 'react';
import Toast from '.';


export enum ToastType {
  DANGER = 'Danger',
  SUCCESS = 'Success',
  INFO = 'Info',
  WARNING = 'Warning'
}

interface ToastProperties {
  id: number;
  title: ToastType;
  backgroundColor: string;
  description: string;
  customClass: string;
}

const TOAST_PROPERTIES: ToastProperties[] = [
  {
    id: Math.floor(Math.random() * 101 + 1),
    title: ToastType.SUCCESS,
    backgroundColor: '#FF1919',
    description: '',
    customClass:"text-green-800 border-green-300 bg-green-50 dark:text-green-400 dark:bg-gray-800 dark:border-green-800"
  },
  {
    id: Math.floor(Math.random() * 101 + 1),
    title: ToastType.DANGER,
    backgroundColor: '#FF1919',
    description: '',
    customClass:"text-red-800 border-red-300 bg-red-50 dark:text-red-400 dark:bg-gray-800 dark:border-red-800"
  },
  {
    id: Math.floor(Math.random() * 101 + 1),
    title: ToastType.INFO,
    backgroundColor: '#00B2FF',
    description: '',
    customClass:"text-blue-800 border-blue-300 bg-blue-50 dark:text-blue-400 dark:bg-gray-800 dark:border-blue-800"
  },
  {
    id: Math.floor(Math.random() * 101 + 1),
    title: ToastType.WARNING,
    backgroundColor: '#FFBE40',
    description: '',
    customClass:"text-yellow-800 border-yellow-300 bg-yellow-50 dark:text-yellow-300 dark:bg-gray-800 dark:border-yellow-800"
  }
];

interface ToastContextType {
  show: (message: string, type?: ToastType) => void;
}

const Ctx = createContext<ToastContextType>({
  show: (message: string, type?: ToastType) => {}
});

interface ToastProviderProps {
  children: ReactNode;
}

export const ToastProvider: React.FC<ToastProviderProps> = ({ children }) => {
  const [list, setList] = useState<ToastProperties[]>([]);

  const show = (message: string, type: ToastType = ToastType.SUCCESS) => {
    const toastProperties = TOAST_PROPERTIES.find(
      (toast) => toast.title.toLowerCase() === type.toLowerCase()
    );
    if (toastProperties) {
      setList([...list, { ...toastProperties, description: message }]);
    }
  };

  return (
    <Ctx.Provider value={{ show }}>
      {children}
      <Toast toastList={list} />
    </Ctx.Provider>
  );
}

export const useToasts = () => useContext(Ctx);
